module.exports = __webpack_public_path__ + "media/images/gallery/4-8de971a0e73de9d60e639546b359c316.jpg";